export function normalizeBackendTimestampToIsoUtc(raw: string) {
  // Backend sometimes returns timestamps like `2026-01-31T19:51:04.641154` (no timezone, microseconds).
  // JS Date parsing treats "no timezone" as local time; if backend meant UTC, relative times become wrong.
  let s = String(raw || '').trim()
  if (!s) return s

  // Trim/pad fractional seconds to milliseconds (3 digits) for safer parsing.
  // - ".641154" -> ".641"
  // - ".6"      -> ".600"
  // - ".64"     -> ".640"
  s = s.replace(/(\.\d{3})\d+/, '$1')
  s = s.replace(/(\.\d)(?=Z$|[+-]\d{2}:?\d{2}$|$)/, '$100')
  s = s.replace(/(\.\d{2})(?=Z$|[+-]\d{2}:?\d{2}$|$)/, '$10')

  // If no timezone/offset present, assume UTC.
  if (!/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) s += 'Z'
  return s
}

export function formatRelative(isoLike: string) {
  const d = new Date(normalizeBackendTimestampToIsoUtc(isoLike))
  const ms = Date.now() - d.getTime()
  if (!Number.isFinite(ms)) return ''
  if (ms < 0) return 'just now'
  const mins = Math.floor(ms / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

export function formatExactTime(isoLike: string): string {
  const raw = String(isoLike || '').trim()
  if (!raw) return '—'
  const d = new Date(normalizeBackendTimestampToIsoUtc(raw))
  if (!Number.isFinite(d.getTime())) return '—'
  return d.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })
}

